import React from 'react';

// Styles Mostly from Bootstrap
const TooltipStyle = {
  position: 'absolute',
  padding: '0 5px',
  zIndex: '1501',
};

const TooltipArrowStyle = {
  position: 'absolute',
  width: 0,
  height: 0,
  borderRightColor: 'transparent',
  borderLeftColor: 'transparent',
  borderTopColor: 'transparent',
  borderBottomColor: 'transparent',
  borderStyle: 'solid',
};

const PlacementStyles = {
  left: {
    tooltip: { marginLeft: -3, padding: '0 5px' },
    arrow: {
      right: 0,
      marginTop: -5,
      borderWidth: '5px 0 5px 5px',
      borderLeftColor: 'var(--md-surface)',
    },
  },
  right: {
    tooltip: { marginRight: 3, padding: '0 5px' },
    arrow: {
      left: 0,
      marginTop: -5,
      borderWidth: '5px 5px 5px 0',
      borderRightColor: 'var(--md-surface)',
    },
  },
  top: {
    tooltip: { marginTop: -3, padding: '5px 0' },
    arrow: {
      bottom: 0,
      marginLeft: -5,
      borderWidth: '5px 5px 0',
      borderTopColor: 'var(--md-surface)',
    },
  },
  bottom: {
    tooltip: { marginBottom: 3, padding: '5px 0' },
    arrow: {
      top: 0,
      marginLeft: -5,
      borderWidth: '0 5px 5px',
      borderBottomColor: 'var(--md-surface)',
    },
  },
};

class Popover extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { placement = 'left' } = this.props;
    const placementStyle = PlacementStyles[placement];

    const {
      style,
      arrowOffsetLeft: left = placementStyle.arrow.left,
      arrowOffsetTop: top = placementStyle.arrow.top,
      children,
      width,
    } = this.props;

    const TooltipInnerStyle = {
      color: 'var(--text-primary)',
      width: width || '300px',
      textAlign: 'center',
      borderRadius: 'var(--radius-md)',
      backgroundColor: 'var(--surface-primary)',
      border: '1px solid var(--border-default)',
      boxShadow: 'var(--shadow-dropdown)',
      fontSize: '14px',
    };

    return (
      <div className="popover-container">
        <div
          style={{
            ...TooltipArrowStyle,
            ...placementStyle.arrow,
            left,
            top,
          }}
        />
        <div style={TooltipInnerStyle}>{children}</div>
      </div>
    );
  }
}
export default Popover;
